import { css } from '@emotion/react';
import * as React from 'react';

const summaryStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.35rem;
	margin: 0 0 1.25rem;
`;

/** Joins organization names in French: "A", "A et B", or "A, B et C" — never an Oxford comma before "et". */
function formatOrganizationNames(names: readonly string[]): string {
	if (names.length === 1) {
		return names[0] ?? '';
	}

	const lastName = names[names.length - 1] ?? '';
	return `${names.slice(0, -1).join(', ')} et ${lastName}`;
}

type Props = {
	readonly organizationNames: readonly string[];
	readonly roleLabel: string | null;
	readonly facilityNames: readonly string[];
};

/**
 * The organization/role/facilities reminder, shared by every invitation state that has no password
 * form to render (`InvitationBySso`, `InvitationUnavailable`). `InvitationDetails` keeps its own copy
 * rather than importing this one: it stays untouched, to the byte, for the `password` path (§8.5).
 */
const InvitationSummary: React.FC<Props> = ({ organizationNames, roleLabel, facilityNames }) => {
	const facilities = facilityNames.length > 0 ? facilityNames.join(', ') : '—';
	const organizations = formatOrganizationNames(organizationNames);

	return (
		<React.Fragment>
			<p>
				Vous êtes invité(e) à rejoindre <strong>{organizations}</strong>.
			</p>
			<dl css={summaryStyle}>
				<dt>Rôle</dt>
				<dd>{roleLabel ?? '—'}</dd>
				<dt>Agences</dt>
				<dd>{facilities}</dd>
			</dl>
		</React.Fragment>
	);
};

export default InvitationSummary;
